/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_Title_SuccessInputs */

const cs_import_done_title_success = /** @type {(inputs: Import_Done_Title_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import dokončen`)
};

const en_import_done_title_success = /** @type {(inputs: Import_Done_Title_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import complete`)
};

/**
* | output |
* | --- |
* | "Import complete" |
*
* @param {Import_Done_Title_SuccessInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_title_success = /** @type {((inputs?: Import_Done_Title_SuccessInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_Title_SuccessInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_title_success(inputs)
	return cs_import_done_title_success(inputs)
});